"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFFILIATE_ADDRESS = exports.DEFAULT_SOURCE = exports.MAX_ZRX_TRADE = exports.MAX_ALLOWANCE = void 0;
const api_1 = require("../../../api");
exports.MAX_ALLOWANCE = '100000000000000000000000000';
exports.MAX_ZRX_TRADE = '100000000000000000000000000';
exports.DEFAULT_SOURCE = [{ name: api_1.SwapperName.Zrx, proportion: '1' }];
exports.AFFILIATE_ADDRESS = '0xc770eefad204b5180df6a14ee197d99d808ee52d';
